@if (isDevMode) {
  <dev-tools />
}

<!-- <global-site-notification /> -->

<router-outlet />

<!-- A collection of all app modals -->
<app-modals />
<!-- Application modals will be projected (rendered) in this modal -->
<app-modal-v2 />
<!-- App-wide search, opened from anywhere via SearchModalService -->
<search-panel />
